export default "__VITE_ASSET__Cuwt_E4u__"